// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__b4YoN","container":"styles_container__1H-nf","title":"styles_title__30ALP","wrapper":"styles_wrapper__2kPV1","answer":"styles_answer__1CYTF"};